<mat-slide-toggle
  [(ngModel)]="value"
  (keydown)="$event.preventDefault()"
  (click)="onClick(); $event.preventDefault()"
  [disabled]="disabled"
  disableRipple="true"
>
</mat-slide-toggle>
